import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import {format} from 'date-fns'

const DateCell = ({getValue}) => {
  const date = getValue()
  return <Box>{format(new Date(date), 'dd MMM yyyy')}</Box>
}

DateCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export default DateCell
